module.exports = __webpack_public_path__ + "img/9788950962197.813f20f8.jpg";